// Menu Data types
export const SET_SELECTED = "SET_SELECTED";

// User Data Types
export const SIGNUP_USER_AND_GET_TOKEN = "SIGNUP_USER_AND_GET_TOKEN";
export const LOGIN_USER_AND_GET_TOKEN = "LOGIN_USER_AND_GET_TOKEN";
export const GET_USER_DATA = "GET_USER_DATA";
export const GET_USER_POSTS = "GET_USER_POSTS";
export const GET_ALL_POSTS = "GET_ALL_POSTS";
export const ADD_POSTS = "ADD_POSTS";
export const UPDATE_POST = "UPDATE_POST";
export const DELETE_POST = "DELETE_POST";
export const SET_CURRENT = "SET_CURRENT";
export const SET_AUTH_LOADING = "SET_AUTH_LOADING";
export const SET_USER_LOADING = "SET_USER_LOADING";
export const SET_USER_POSTS_LOADING = "SET_USER_POSTS_LOADING";
export const SET_ALL_POSTS_LOADING = "SET_ALL_POSTS_LOADING";
export const LOGOUT = "LOGOUT";
